export default "__VITE_ASSET__2301032c__"